























































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { LecturePageCreate as ILecturePageCreate } from "@/api/models/lecture-page-create";
import { LecturePages as ILecturePages } from "@/api/models/lecture-pages";
import { LecturePage as ILecturePage } from "@/api/models/lecture-page";
import { LecturePageEdit as ILecturePageEdit } from "@/api/models/lecture-page-edit";
import { Sort as ISort } from "@/api/models/sort";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
// @ts-ignore
import draggableComponent from "vuedraggable";

//TODO: Переделать добавление страниц лекции после того как будет возможность создавать страницы лекций с помощью массива

@Component({
  components: { draggableComponent, EditorWithFile }
})
export default class LecturePagesCreate extends Vue {
  @Prop(String) lectureId!: string;
  @Prop() lecturePageEditable?: Array<ILecturePages>;
  lecturePages!: Array<ILecturePageCreate>;
  lecturePageBody!: string;
  sort: number = 0;
  newPageSort: number = 90; // TODO временное решение для добавления новых страниц в конец массива
  editPageBody!: string | undefined;
  idsToDeleteLecturePage: Array<string> = [];
  existLecturePageEditable!: Array<ILecturePages>;
  showSpinner: boolean = true;
  currentLecturePageId!: string;
  sortArray!: Array<ISort>;
  editTree: boolean = false;

  data() {
    return {
      lecturePageBody: "",
      currentLecturePageId: undefined,
      lecturePages: [],
      editPageBody: "",
      existLecturePageEditable: [],
      sortArray: []
    };
  }

  @Watch("lecturePageEditable")
  getExistLecturePage() {
    if (this.lecturePageEditable) {
      this.existLecturePageEditable = this.lecturePageEditable;
    }
  }

  mounted() {
    this.getExistLecturePage();
  }

  showModalAddPage() {
    this.$bvModal.show("createPage");
  }

  // Show modal edit not created lecture page
  showModalEditPage(index: number, lecturePage: ILecturePageCreate) {
    this.$bvModal.show("edit-lecture-page-" + index);
    this.editPageBody = lecturePage.body;
  }

  closeModal() {
    this.editPageBody = "";
    this.showSpinner = true;
  }

  newShowModalEditExistPage(lecturePageId: string) {
    this.showSpinner = true;
    this.$bvModal.show("edit-exist-lecture-page");
    api.LecturePageApi.get(this.lectureId, lecturePageId)
      .then((res: { data: ILecturePage }) => {
        this.editPageBody = res.data.body;
        this.currentLecturePageId = res.data.id;
        this.showSpinner = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  applySort() {
    if (this.lecturePages) {
      this.sort = 0;
      this.sortArray.forEach((element: ILecturePages) => {
        this.sort += 1;
        element.sort = this.sort;
      });
      this.$emit("sortSlide", this.lecturePages);
    }
  }

  // Add new lecture page to array
  addLecturePage() {
    let arg: ILecturePageCreate = {
      body: this.lecturePageBody,
      sort: this.existLecturePageEditable?.length + this.lecturePages.length
    };
    this.lecturePages.push(arg);
    this.$emit("addLecturePage", this.lecturePages);
    this.lecturePageBody = "";
    this.$bvModal.hide("createPage");
    this.sort += 1;
  }

  // Edit not created lecture page
  editLecturePage(item: ILecturePageCreate, index: number) {
    if (this.editPageBody != null) {
      item.body = this.editPageBody;
    }
    this.$bvModal.hide("edit-lecture-page-" + index);
    this.$emit("editLecturePage", this.lecturePages);
  }

  // Edit existing lecture page
  newEditExistLecturePage() {
    const lecture: ILecturePageEdit = {
      body: this.editPageBody
    };
    api.LecturePageApi.edit(this.lectureId, this.currentLecturePageId, lecture)
      .then(() => {
        this.$emit("editExistLecturePage", this.existLecturePageEditable);
        this.$bvModal.hide("edit-exist-lecture-page");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  // Delete not created lecture page
  deleteLecturePage(item: ILecturePageCreate) {
    this.lecturePages = this.lecturePages.filter(element => {
      return element !== item;
    });
  }

  // Delete existing lecture page
  deleteExistLecturePage(
    lecturePageId: string,
    existLecture: ILecturePageEdit
  ) {
    this.idsToDeleteLecturePage.push(lecturePageId);
    this.existLecturePageEditable = this.existLecturePageEditable.filter(
      element => {
        return element !== existLecture;
      }
    );
    this.$emit("idsLecturePageToDelete", this.idsToDeleteLecturePage);
  }

  filterPageBodyLength(lectureBody: string) {
    if (lectureBody.length > 60) {
      return lectureBody.substr(0, 50).replace(/(<(\/?[^>]+)>)/g, "") + "...";
    } else {
      return lectureBody.replace(/(<(\/?[^>]+)>)/g, "");
    }
  }
}
